class LoadMore {
  constructor() {
    this.loadMoreBtn = document.querySelector('.load-more-btn');
    this.productGrid = document.querySelector('#product-grid');
    this.loadMoreWrapper = document.querySelector('.load-more-wrapper');
    this.productsShown = document.querySelector('.products-shown');

    if (this.loadMoreBtn) {
      this.init();
    }
  }

  init() {
    this.loadMoreBtn.addEventListener('click', this.handleLoadMore.bind(this));
  }

  async handleLoadMore(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const nextUrl = button.dataset.nextUrl;
    const currentPage = parseInt(button.dataset.currentPage);
    const totalPages = parseInt(button.dataset.totalPages);

    if (!nextUrl) return;

    // Show loading state
    this.setLoadingState(true);

    try {
      // Fetch the next page
      const response = await fetch(nextUrl);
      const html = await response.text();

      // Parse the response
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Get new products
      const newProducts = doc.querySelectorAll('#product-grid .grid__item');
      const newPagination = doc.querySelector('.load-more-wrapper');

      if (newProducts.length > 0) {
        // Add new products to the grid
        this.appendProducts(newProducts);

        // Update pagination or remove if on last page
        this.updatePagination(newPagination, currentPage + 1, totalPages);

        // Update products shown count
        this.updateProductCount();

        // Trigger any animations or events
        this.triggerProductLoadedEvent();
      }
    } catch (error) {
      console.error('Error loading more products:', error);
      this.showError();
    } finally {
      this.setLoadingState(false);
    }
  }

  appendProducts(newProducts) {
    const fragment = document.createDocumentFragment();

    newProducts.forEach((product, index) => {
      // Clone the product element
      const productClone = product.cloneNode(true);

      // Add animation class
      productClone.classList.add('product-loaded');

      // Stagger animation delay
      productClone.style.animationDelay = `${index * 0.1}s`;

      fragment.appendChild(productClone);
    });

    this.productGrid.appendChild(fragment);
  }

  updatePagination(newPagination, nextPage, totalPages) {
    if (nextPage >= totalPages || !newPagination) {
      // Remove load more button if we're on the last page
      this.loadMoreWrapper.remove();
    } else {
      // Update button with next page data
      const newBtn = newPagination.querySelector('.load-more-btn');
      if (newBtn) {
        this.loadMoreBtn.dataset.nextUrl = newBtn.dataset.nextUrl;
        this.loadMoreBtn.dataset.currentPage = newBtn.dataset.currentPage;
      }
    }
  }

  updateProductCount() {
    if (this.productsShown) {
      const currentCount = this.productGrid.children.length;
      this.productsShown.textContent = currentCount;
    }
  }

  setLoadingState(isLoading) {
    const spinner = this.loadMoreBtn.querySelector('.load-more-spinner');
    const text = this.loadMoreBtn.querySelector('.load-more-text');

    if (isLoading) {
      this.loadMoreBtn.disabled = true;
      spinner.classList.remove('hidden');
      text.classList.add('hidden');
      document.body.classList.add('product-grid-loading');
    } else {
      this.loadMoreBtn.disabled = false;
      spinner.classList.add('hidden');
      text.classList.remove('hidden');
      document.body.classList.remove('product-grid-loading');
    }
  }

  showError() {
    const text = this.loadMoreBtn.querySelector('.load-more-text');
    const originalText = text.textContent;

    text.textContent = 'Error loading products';
    text.style.color = 'rgb(var(--color-error))';

    setTimeout(() => {
      text.textContent = originalText;
      text.style.color = '';
    }, 3000);
  }

  triggerProductLoadedEvent() {
    // Dispatch custom event for other scripts that might need to know
    const event = new CustomEvent('productsLoaded', {
      detail: {
        newProductCount: this.productGrid.children.length,
      },
    });
    document.dispatchEvent(event);

    // Re-initialize any product-specific functionality
    this.reinitializeProductFeatures();
  }

  reinitializeProductFeatures() {
    // Re-run any product card specific JavaScript
    // This might include quick add functionality, hover effects, etc.

    // Example: Re-initialize quick add buttons
    if (window.ProductCard) {
      const newProducts = this.productGrid.querySelectorAll('.product-loaded');
      newProducts.forEach((product) => {
        new window.ProductCard(product);
      });
    }

    // Remove the animation class after animation completes
    setTimeout(() => {
      const loadedProducts = this.productGrid.querySelectorAll('.product-loaded');
      loadedProducts.forEach((product) => {
        product.classList.remove('product-loaded');
      });
    }, 500);
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new LoadMore();
});

// Re-initialize after AJAX updates (for faceted search compatibility)
document.addEventListener('facetsUpdated', () => {
  new LoadMore();
});
